import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id E39F6865-3E35-4BE8-8440-643FC83351F7
 * name note-text-outline
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-text-outline.svg
 * tags
 */
export const NoteTextOutlineIcon = createSvgIcon(<><path d="M15 3H5A2 2 0 0 0 3 5V19A2 2 0 0 0 5 21H19A2 2 0 0 0 21 19V9L15 3M19 19H5V5H14V10H19M17 14H7V12H17M14 17H7V15H14" /></>, 'NoteTextOutlineIcon');
export default NoteTextOutlineIcon